export default [
  {
    path: '/plans/garden/list',
    name: 'plans.garden.list',
    component: () => import('@/views/modules/plans/garden-plan/plans-list/ListGardenPlans'),
    meta: {
      module: 'plans.garden',
      pageTitle: 'List All Garden Plans',
      breadcrumb: [
        { text: 'List Garden Plans', active: true, },
        { text: 'Create Plan', to: {name: 'plans.garden.create'} }
      ],
    }
  },


  {
    path: '/plans/garden/create',
    name: 'plans.garden.create',
    component: () => import('@/views/modules/plans/garden-plan/create/CreateGardenPlan'),
    meta: {
      module: 'plans.garden',
      pageTitle: 'Plan Create',
      breadcrumb: [
        { text: 'List Plans', to: {name: 'plans.garden.list'} },
        { text: 'Create Plan' , active: true}
      ],
    }
  },


  {
    path: '/plans/garden/:id/edit',
    name: 'plans.garden.edit',
    component: () => import('@/views/modules/plans/garden-plan/edit/EditGardenPlan'),
    meta: {
      module: 'plans.garden',
      pageTitle: 'Garden Plan Edit',
      breadcrumb: [
        { text: 'List Plans', to: {name: 'plans.garden.list'} },
        { text: 'Create Plan' , to: {name: 'plans.garden.create'}},
        { text: 'Edit Plan' , active: true}
      ],
    }
  },
]
